'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DOC_MODE_DEBUG_TOOL_NAME = exports.DOC_MODE_DEBUG_TOOL_NAME = 'documentMode';


//////////////////
// WEBPACK FOOTER
// ./src/client/debug/documentMode/debugDocumentModeConstants.js
// module id = 448
// module chunks = 0